import { getAppConfig } from "config/client.config";
import _ from "lodash";

export const FETCH_COURSE = "FETCH_COURSE";
export const GAMIFY_COURSE = "GAMIFY_COURSE";
export const NOTIFY_COURSE = "NOTIFY_COURSE";
export const RENAME_COURSE = "RENAME_COURSE";
export const UPDATE_COURSE_ACCESS = "UPDATE_COURSE_ACCESS";
export const UPDATE_COURSE_TAGS = "UPDATE_COURSE_TAGS";
export const CHANGE_COURSE_IMAGE = "CHANGE_COURSE_IMAGE";
export const TOGGLE_SEQUENTIAL_COURSE = "TOGGLE_SEQUENTIAL_COURSE";
export const TOGGLE_LAUNCH_COURSE = "TOGGLE_LAUNCH_COURSE";

const _fetchCourse = (status, data, err) => {
    return {
        type: FETCH_COURSE,
        data,
        err,
        status,
    };
};
const _gamifyCourse = (status, data, err) => {
    return {
        type: GAMIFY_COURSE,
        data,
        err,
        status,
    };
};
const _notifyCourse = (status, data, err) => {
    return {
        type: NOTIFY_COURSE,
        data,
        err,
        status,
    };
};
const _renameCourse = (status, data, err) => {
    return {
        type: RENAME_COURSE,
        data,
        err,
        status,
    };
};
const _updateCourseAccess = (status, data, err) => {
    return {
        type: UPDATE_COURSE_ACCESS,
        data,
        err,
        status,
    };
};
const _updateCourseTags = (status, data, err) => {
    return {
        type: UPDATE_COURSE_TAGS,
        data,
        err,
        status,
    };
};
const _changeCourseImage = (status, data, err) => {
    return {
        type: CHANGE_COURSE_IMAGE,
        data,
        err,
        status,
    };
};
const _toggleSequentialCourse = (status, data, err) => {
    return {
        type: TOGGLE_SEQUENTIAL_COURSE,
        data,
        err,
        status,
    };
};
const _toggleLaunchCourse = (status, data, err) => {
    return {
        type: TOGGLE_LAUNCH_COURSE,
        data,
        err,
        status,
    };
};

const fetchCourse = (courseId) => {
    return (dispatch, getState, Request) => {
        let targetPath =
            courseId === undefined
                ? getAppConfig().endpoints.contentPaths["ldCoursePath"]
                : getAppConfig().endpoints.contentPaths[
                      "getCoursePath"
                  ].replace(":id", courseId);
        return Request.fetch(targetPath)
            .then((response) => {
                return response.json().then((data) => {
                    return dispatch(_fetchCourse("success", data, null));
                });
            })
            .catch((err) => {
                console.log(err);
                return dispatch(_fetchCourse("error", null, err));
            });
    };
};

const createCategory = /* istanbul ignore next - redux passthrough function */ (
    name,
    description,
    icon,
    priority
) => {
    return (dispatch, getState, Request) => {
        let createCategoryPath = getAppConfig().endpoints.builderPaths[
            "createCategoryPath"
        ];
        return Request.fetch(createCategoryPath, {
            method: "POST",
            body: JSON.stringify({
                name: name,
                description: description,
                image: icon,
                list_type: "Course",
                priority: priority,
            }),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {})
            .catch((err) => {
                console.log(err);
            });
    };
};

const updateCategory = /* istanbul ignore next - redux passthrough function */ (
    id,
    name,
    description,
    icon,
    priority
) => {
    return (dispatch, getState, Request) => {
        let updateCategoryPath = getAppConfig().endpoints.builderPaths[
            "updateCategoryPath"
        ].replace(":id", id);
        let body = { name: name, description: description, priority: priority };
        if (icon !== undefined) body.image = icon;
        return Request.fetch(updateCategoryPath, {
            method: "POST",
            body: JSON.stringify(body),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {})
            .catch((err) => {
                console.log(err);
            });
    };
};

const gamifyCourse = /* istanbul ignore next - redux passthrough function */ (
    wrapper
) => {
    return (dispatch, getState, Request) => {
        let gamifyPath = getAppConfig().endpoints.builderPaths[
            "updateCoursePath"
        ].replace(":id", getState().editingCourse._id);
        return Promise.resolve(
            dispatch(
                _gamifyCourse(
                    "gamifying course",
                    {
                        wrapper: wrapper,
                    },
                    null
                )
            )
        ).then(() => {
            return Request.fetch(gamifyPath, {
                method: "POST",
                body: JSON.stringify({
                    wrapper: wrapper,
                }),
            })
                .then((resp) => {
                    return resp.json();
                })
                .then((response) => {})
                .catch((err) => {
                    console.log(err);
                });
        });
    };
};
const notifyCourse = /* istanbul ignore next - redux passthrough function */ (
    notificationsObj
) => {
    return (dispatch, getState, Request) => {
        let notifyPath = getAppConfig().endpoints.builderPaths[
            "updateCoursePath"
        ].replace(":id", getState().editingCourse._id);
        return Promise.resolve(
            dispatch(
                _notifyCourse(
                    "adding notifications to course",
                    { notifications: notificationsObj },
                    null
                )
            )
        ).then(() => {
            return Request.fetch(notifyPath, {
                method: "POST",
                body: JSON.stringify({ notifications: notificationsObj }),
            })
                .then((resp) => {
                    return resp.json();
                })
                .then((response) => {})
                .catch((err) => {
                    console.log(err);
                });
        });
    };
};

const triggerAllNotification = (courseId, message, medium) => {
    return (dispatch, getState, Request) => {
        let notifyAllPath = getAppConfig().endpoints.learnerManagerPaths[
            "notifyAllPath"
        ];
        notifyAllPath = _.replace(notifyAllPath, ":id", courseId);
        return Request.fetch(notifyAllPath, {
            method: "POST",
            body: JSON.stringify({
                message: message,
                medium: medium,
            }),
        })
            .then((response) => {
                return response.json().then((data) => {
                    return dispatch(
                        _notifyCourse(
                            "adding notifications to course",
                            { notifications: data },
                            null
                        )
                    );
                });
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const renameCourse = /* istanbul ignore next - redux passthrough function */ (
    name,
    description,
    category,
    competencies,
    points,
    coins,
    priority,
    baseColor,
    primaryColor,
    primaryColorText
) => {
    return (dispatch, getState, Request) => {
        let thisId = getState().editingCourse._id;
        let renamePath = getAppConfig().endpoints.builderPaths[
            "updateCoursePath"
        ].replace(":id", thisId);
        return Promise.resolve(
            dispatch(
                _renameCourse(
                    "renaming course",
                    {
                        id: thisId,
                        name: name,
                        description: description,
                        category: category.split("program")[1],
                        competencies: competencies,
                        points: points,
                        coins: coins,
                        priority: priority,
                        colors: {
                            base: baseColor,
                            primary: primaryColor,
                            primaryText: primaryColorText,
                        },
                    },
                    null
                )
            )
        ).then(() => {
            return Request.fetch(renamePath, {
                method: "POST",
                body: JSON.stringify({
                    name: name,
                    description: description,
                    parent: category.split("program")[1],
                    competencies: competencies,
                    points: points,
                    coins: coins,
                    priority: priority,
                    colors: {
                        base: baseColor,
                        primary: primaryColor,
                        primaryText: primaryColorText,
                    },
                }),
            })
                .then((resp) => {
                    return resp.json();
                })
                .then((response) => {})
                .catch((err) => {
                    console.log(err);
                });
        });
    };
};

const updateCourseAccess = /* istanbul ignore next - redux passthrough function */ (
    start_date,
    end_date,
    vintage,
    enableTiming,
    autoNotification
) => {
    return (dispatch, getState, Request) => {
        let updateAccessPath = getAppConfig().endpoints.builderPaths[
            "updateCoursePath"
        ].replace(":id", getState().editingCourse._id);
        return Promise.resolve(
            dispatch(
                _updateCourseAccess(
                    "updating course access",
                    {
                        start_date: start_date,
                        end_date: end_date,
                        vintage: vintage,
                        enable_timing: enableTiming,
                        autoNotification: autoNotification,
                    },
                    null
                )
            )
        ).then(() => {
            return Request.fetch(updateAccessPath, {
                method: "POST",
                body: JSON.stringify({
                    dates: {
                        start_date: start_date,
                        end_date: end_date,
                    },
                    vintage: vintage,
                    enable_timing: enableTiming,
                    autoNotification: autoNotification,
                }),
            })
                .then((resp) => {
                    return resp.json();
                })
                .then((response) => {})
                .catch((err) => {
                    console.log(err);
                });
        });
    };
};

const updateCourseTags = /* istanbul ignore next - redux passthrough function */ (
    tagList
) => {
    return (dispatch, getState, Request) => {
        let createCourseTagsPath = getAppConfig().endpoints.builderPaths[
            "updateCoursePath"
        ].replace(":id", getState().editingCourse._id);
        return Promise.resolve(
            dispatch(
                _updateCourseTags(
                    "updating course tags",
                    {
                        cohort_tags: tagList,
                    },
                    null
                )
            )
        ).then(() => {
            return Request.fetch(createCourseTagsPath, {
                method: "POST",
                body: JSON.stringify({
                    tag_list: tagList.join(", "),
                }),
            })
                .then((resp) => {
                    return resp.json();
                })
                .then((response) => {})
                .catch((err) => {
                    console.log(err);
                });
        });
    };
};

const changeCourseImage = /* istanbul ignore next - redux passthrough function */ (
    image,
    type
) => {
    return (dispatch, getState, Request) => {
        let thisId = getState().editingCourse._id;
        let changePath = getAppConfig().endpoints.builderPaths[
            "updateCoursePath"
        ].replace(":id", thisId);
        return Request.fetch(changePath, {
            method: "POST",
            body:
                type == null
                    ? JSON.stringify({
                          image: image,
                      })
                    : JSON.stringify({
                          logo: image,
                      }),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return Promise.resolve(
                    dispatch(
                        _changeCourseImage(
                            "changing course image",
                            type == null
                                ? {
                                      id: thisId,
                                      image: response.image,
                                  }
                                : {
                                      id: thisId,
                                      logo: response.logo,
                                  },
                            null
                        )
                    )
                );
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const toggleSequentialCourse = /* istanbul ignore next - redux passthrough function */ () => {
    return (dispatch, getState, Request) => {
        let renamePath = getAppConfig().endpoints.builderPaths[
            "updateCoursePath"
        ].replace(":id", getState().editingCourse._id);
        return Promise.resolve(
            dispatch(
                _toggleSequentialCourse(
                    "toggling sequential course",
                    {
                        sequential: !getState().editingCourse.sequential,
                    },
                    null
                )
            )
        ).then(() => {
            return Request.fetch(renamePath, {
                method: "POST",
                body: JSON.stringify({
                    sequential: getState().editingCourse.sequential,
                }),
            })
                .then((resp) => {
                    return resp.json();
                })
                .then((response) => {})
                .catch((err) => {
                    console.log(err);
                });
        });
    };
};

const fetchCategories = () => {
    return (dispatch, getState, Request) => {
        let creatorLibraryPath = getAppConfig().endpoints.creatorLibraryPath;
        return Request.fetch(creatorLibraryPath)
            .then((response) => {
                return response.json().then((data) => {
                    return _.union(
                        [
                            {
                                id: "program0",
                                name: "Application",
                                programId: null,
                            },
                        ],
                        _.map(data, (program) => {
                            return {
                                id: "program" + program._id,
                                name: program.name,
                                description: program.description,
                                image: program.image,
                                programId:
                                    program.parent === null
                                        ? "program0"
                                        : "program" + program.parent,
                                priority: program.priority,
                            };
                        })
                    );
                });
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const createArticle = (articleHash) => {
    return (dispatch, getState, Request) => {
        let createArticlePath = getAppConfig().endpoints.createArticlePath;
        return Request.fetch(createArticlePath, {
            method: "POST",
            body: JSON.stringify(articleHash),
        })
            .then((resp) => {
                return resp.json();
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const launchCourse = /* istanbul ignore next - redux passthrough function */ () => {
    return (dispatch, getState, Request) => {
        let renamePath = getAppConfig().endpoints.builderPaths[
            "updateCoursePath"
        ].replace(":id", getState().editingCourse._id);
        return Promise.resolve(
            dispatch(
                _toggleLaunchCourse(
                    "toggling launch course",
                    {
                        launch: !getState().editingCourse.launch,
                    },
                    null
                )
            )
        ).then(() => {
            return Request.fetch(renamePath, {
                method: "POST",
                body: JSON.stringify({
                    launch: getState().editingCourse.launch,
                }),
            })
                .then((resp) => {
                    return resp.json();
                })
                .then((response) => {})
                .catch((err) => {
                    console.log(err);
                });
        });
    };
};

class CourseEditorAction {
    static createCategory = createCategory;
    static updateCategory = updateCategory;
    static fetchCourse = fetchCourse;
    static gamifyCourse = gamifyCourse;
    static notifyCourse = notifyCourse;
    static triggerAllNotification = triggerAllNotification;
    static renameCourse = renameCourse;
    static updateCourseAccess = updateCourseAccess;
    static updateCourseTags = updateCourseTags;
    static changeCourseImage = changeCourseImage;
    static toggleSequentialCourse = toggleSequentialCourse;
    static fetchCategories = fetchCategories;
    static createArticle = createArticle;
    static launchCourse = launchCourse;
}

export default CourseEditorAction;
